export class GRNCateCode {
    static Herb = 1;
    static Pill = 4;
    static ConcMedi = 2;
    static Powder = 3;
    static StockItem = 5;
    static Null = null;

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}